import { tool as pencil } from './pencil';
import { tool as brush } from './brush';
import { tool as eraser } from './eraser';
import { tool as circle } from './circle';
import { tool as square } from './square';
import { tool as triangle } from './triangle';
import { tool as line } from './line';
import { tool as hand } from './hand';


export default {
    pencil,
    brush,
    eraser,
    circle,
    square,
    triangle,
    line,
    hand
}